import { Injectable, Provider } from '@angular/core';
import { HomeworkActivityQuery, HomeworkActivityService, HomeworkActivityStoreModel } from '@examdojo/homework';
import {
  ACTIVITY_MISMATCH_ADAPTER,
  ActivityMismatchAdapter,
  FetchAttemptWhenMismatchEffectService,
} from '@examdojo/question';
import { map } from 'rxjs';

@Injectable()
export class HomeworkActivityMismatchAdapter implements ActivityMismatchAdapter<HomeworkActivityStoreModel> {
  constructor(
    private readonly homeworkActivityQuery: HomeworkActivityQuery,
    private readonly homeworkActivityService: HomeworkActivityService,
  ) {}

  readonly ongoingActivityId$ = this.homeworkActivityQuery.ongoingActivity$.pipe(map((activity) => activity?.id));

  selectEntity(id: string) {
    return this.homeworkActivityQuery.selectEntity(id);
  }

  fetchAttempt(attemptId: string, activity: HomeworkActivityStoreModel) {
    return this.homeworkActivityService.fetchQuestionAttempts(attemptId, activity.id);
  }
}

export function provideHomeworkActivityMismatchEffect(): Provider[] {
  return [
    HomeworkActivityMismatchAdapter,
    {
      provide: ACTIVITY_MISMATCH_ADAPTER,
      useExisting: HomeworkActivityMismatchAdapter,
    },
    FetchAttemptWhenMismatchEffectService,
  ];
}
